import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { goBack, push } from 'connected-react-router';

import { closeCommuteModal, openCommuteModal } from '../Actions/ToggleActions';

import { URL_TYPES } from '../Constants';
import logo from '../Images/Icons/logo_black.svg';

import { setPageTitle } from '../Utils/otherUtils';

const AboutService = () => {
  const dispatch = useDispatch();

  const { language } = useSelector(state => state.Language);
  const pageText = useSelector(state => state.Language.text.aboutService);
  setPageTitle(`${pageText.pageTitle}`);

  useEffect(() => {
    dispatch(closeCommuteModal());
  }, []);

  return (
    <div>
      <div className="full-view-page-wrapper">
        <div className="white-bg">
          <div className="top-btn">
            <input
              className="btn close"
              type="button"
              tabIndex="0"
              onClick={() => { dispatch(goBack()); dispatch(openCommuteModal()); }}
            />
          </div>
          <article className="full-view-page-wrapper" aria-label="Om tjänsten">
            <div className="white-bg">
              <div className="header">
                <img className="logo" src={logo} alt="vh-icon" />
              </div>
              <div>
                <div className="main-text-content">
                  <h3>{pageText.sectionMotivation.header}</h3>
                  <p>{pageText.sectionMotivation.content}</p>
                  <ul>
                    {pageText.sectionMotivation.ul.map(li => <li key={li}>{li}</li>)}
                  </ul>
                </div>
                <div className="main-text-content">
                  <h3>{pageText.sectionBackground.header}</h3>
                  <p>{pageText.sectionBackground.content}</p>
                </div>
                <div className="main-text-content">
                  <h3>{pageText.sectionConnect.header}</h3>
                  <p>{pageText.sectionConnect.contentP1}</p>
                  <p>
                    {pageText.sectionConnect.contentP2}
                    <a
                      className="blue-link underline"
                      rel="noopener noreferrer"
                      target="_blank"
                      href={pageText.sectionConnect.href}
                    >{pageText.sectionConnect.href.replace('https://', '')}
                    </a>
                  </p>
                </div>
                <div className="main-text-content">
                  <h3>{pageText.sectionAccessibility.header}</h3>
                  <p>{pageText.sectionAccessibility.content}</p>
                  <ul>
                    {pageText.sectionAccessibility.ul.map(li =>
                      (
                        <li key={li.title}>
                          {li.title}
                          <a
                            className="blue-link underline"
                            rel="noopener noreferrer"
                            target="_blank"
                            href={li.href}
                          >{pageText.readMore}
                          </a>
                        </li>
                     ))}
                  </ul>
                  <p>Tillgänglighetsanalyser</p>
                  <ul>
                    <li>
                      <a
                        className="blue-link underline"
                        rel="noopener noreferrer"
                        target="_blank"
                        download
                        href="https://accessability-declarations.s3-eu-west-1.amazonaws.com/Tillga%CC%88nglighetsredogo%CC%88relse+-+kramfors.docx"
                      >Kramfors
                      </a>
                    </li>
                    <li>
                      <a
                        className="blue-link underline"
                        rel="noopener noreferrer"
                        target="_blank"
                        download
                        href="https://accessability-declarations.s3-eu-west-1.amazonaws.com/Tillg%C3%A4nglighet+f%C3%B6r+V%C3%A4lkommen+hit+-+%C3%85nge.docx"
                      >Ånge
                      </a>
                    </li>
                    <li>
                      <a
                        className="blue-link underline"
                        rel="noopener noreferrer"
                        target="_blank"
                        download
                        href="https://accessability-declarations.s3-eu-west-1.amazonaws.com/Tillg%C3%A4nglighet+V%C3%A4lkommen+hit+-+%C3%96rnsk%C3%B6ldsvik.docx"
                      >Örnsköldsvik
                      </a>
                    </li>
                  </ul>
                </div>
                <div className="main-text-content about-images">
                  <img src="https://s3-eu-west-1.amazonaws.com/prod-welcome-file-storage/EU_centrerad_RGB.png" alt="EU-logo" />
                  <img src="https://s3-eu-west-1.amazonaws.com/prod-welcome-file-storage/dewire_head_with_text.png" alt="Dewire-logo" />
                </div>
              </div>
              <div className="main-text-content">
                <div
                  className="blue-link underline f15"
                  role="link"
                  tabIndex="0"
                  onClick={() => { dispatch(push(`/${language}/${URL_TYPES.ABOUT_SERVICE}/${URL_TYPES.LICENSES}`)); }}
                  onKeyPress={() => { dispatch(push(`/${language}/${URL_TYPES.ABOUT_SERVICE}/${URL_TYPES.LICENSES}`)); }}
                >
                  {pageText.thirdParty}
                </div>
              </div>
            </div>
          </article>
        </div>
      </div>
    </div>
  );
};

export default AboutService;



// WEBPACK FOOTER //
// ./src/Components/AboutService.js